import { Action } from "@ngrx/store";
import { ReduxAction } from "./../actions/redux.action";
import { FacilityModel } from "app/shared/models";

export function LocationReducer(state: FacilityModel, action: ReduxAction) {
  switch (action.type) {
    case "SET_LOCATION_MODAL":
      return Object.assign({}, state, action.get());

    case "CLEAR_LOCATION":
    case "LOGOUT":
      return null;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/reducers/location.reducer.ts